export const testValidationRules = {
  EA: {
    min: 100,
    max: 200,
  },
  GMAT: {
    min: 200,
    max: 800,
  },
  GRE: {
    min: 260,
    max: 340,
  },
  LSAT: {
    min: 120,
    max: 180,
  },
};

export const availableTests = () => Object.keys(testValidationRules);

export const validateTestScore = (test, score) => {
  if (test in testValidationRules) {
    const { min, max } = testValidationRules[test];

    if (!score || score < min || score > max) {
      return `Your ${test} score should be between ${min} and ${max}.`;
    }

    return null;
  }

  return test === '' ? null : 'Invalid test';
};
